/** Maps every source color to orange shades while preserving detail and transparency. */
export function C1_OrangeSelectionFilter({ id }: { id: string }) {
  return (
    <filter id={id} colorInterpolationFilters="sRGB">
      <feColorMatrix type="saturate" values="0" />
      <feComponentTransfer>
        {/* Dark orange (#7c2d12), vivid orange (#f97316), light amber (#ffb347). */}
        <feFuncR type="table" tableValues="0.4863 0.9765 1" />
        <feFuncG type="table" tableValues="0.1765 0.4510 0.7020" />
        <feFuncB type="table" tableValues="0.0706 0.0863 0.2784" />
        <feFuncA type="identity" />
      </feComponentTransfer>
    </filter>
  );
}
